import mutations from './mutations'
import getters from './getters'
import actions from './actions'

const state = {
  tags: [],
  tag: {},
  tagUse: {},
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
